import { useMutation } from "@tanstack/react-query"
import { acceptJourneyMission } from "@/lib/api/quests"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { useQuestsStore } from "@/lib/store/quests"
import { NextJourneyMissionInfo } from "@/hooks/useJourneyData"

export const useStartMission = () => {
  const navigate = useNavigate()
  const { addMissionAttempt } = useQuestsStore()

  const mutation = useMutation({
    mutationFn: (missionInfo: NextJourneyMissionInfo) =>
      acceptJourneyMission(missionInfo.journeyMissionId),
    onSuccess: (data, missionInfo: NextJourneyMissionInfo) => {
      // Store the attemptId in the Zustand store
      if (data && data.id) {
        console.log(
          `Storing attemptId ${data.id} for journeyMissionId ${missionInfo.journeyMissionId}`,
        )
        addMissionAttempt(missionInfo.journeyMissionId, data.id)
      } else {
        console.warn("No attemptId found in the response:", data)
      }

      toast.success("Mission started successfully")
      navigate(`/missions/${missionInfo.missionId}`)
    },
    onError: (error) => {
      console.error("Error starting mission:", error)
      toast.error("Could not start mission. Please try again.")
    },
  })

  const startJourneyMission = (missionInfo: NextJourneyMissionInfo) => {
    mutation.mutate(missionInfo)
  }

  return {
    startJourneyMission,
    isStarting: mutation.isPending,
    error: mutation.error,
  }
}
